import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { Toolbar } from './toolbar.esm.js';
import styles from './uitk-toolbar.css';

var getClassNameList = classNames.bind(styles);
var UitkToolbar = /** @class */ (function (_super) {
    __extends(UitkToolbar, _super);
    function UitkToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkToolbar.prototype.render = function () {
        var _a = this.props, elevation = _a.elevation, className = _a.className, props = __rest(_a, ["elevation", "className"]);
        var elevationClassName = '';
        if (elevation === 'flat') {
            elevationClassName = "".concat(Toolbar.baseClassName, "-").concat(elevation);
        }
        else if (elevation === 'floating') {
            elevationClassName = "".concat(elevation);
        }
        var wrapperClassNames = getClassNameList(elevationClassName, className);
        return React.createElement(Toolbar, __assign({ className: wrapperClassNames }, props));
    };
    UitkToolbar.displayName = 'UitkStandardToolbar';
    return UitkToolbar;
}(React.Component));

export { UitkToolbar };
